import { SelectOption } from "@/ui-kit/select";

export const ANY_REGION_OPTION_LABEL: string = 'Любое'

export const ANY_REGION_OPTION = {
    value: -1,
    label: 'Любое'
}
